<template>
  <div>
    <v-overlay :value="overlay || $store.state.loading_pdf">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-form ref="form" lazy-validation>
      <v-card-text v-bind:style="{ backgroundImage: 'url( https://cdn.vuetifyjs.com/images/parallax/material2.jpg )' }">
        <v-card width="1400" style="margin: 20px auto 0;">
          <v-row>

            <!--======  IMPUT ONDE PESQUISAMOS PELO ESTUDANTE ===== -->
            <v-col md="4">
              <v-autocomplete v-model="estudantePesquisa" :items="estudantesLista" :loading="isLoading_"
                :search-input.sync="search" color="primary" item-text="nome_matricula" item-value="nome"
                label="Pesquise pelo nome, número de Bi ou Matrícula" placeholder="Digite o nome, matricula do estudante"
                prepend-icon="mdi-database-search" return-object @change="PesquisaLocal()"></v-autocomplete>
            </v-col>
            <!--======  FIM IMPUT ONDE PESQUISAMOS PELO ESTUDANTE ===== -->

            <!-- ===== EXIBINDO AS INFORMAÇÕES BÁSICAS SOBRE O ESTUDANTE ===== -->
            <div class="infoEstudanteContainer" v-if="estudanteSelecionado.length">
              <div>
                <span class="text-bold">Nome:</span>
                <span class="totais-font-size"> {{ (estudanteSelecionado.length) ? estudanteSelecionado[0].nome : ''
                }}</span>
              </div>
              <div>
                <span class="text-bold">Nº Matrícula:</span>
                <span> {{ (estudanteSelecionado.length) ? estudanteSelecionado[0].numero_matricula : '' }}</span>
              </div>
              <div>
                <span class="text-bold">Curso:</span>
                <span> {{ (estudanteSelecionado.length) ? estudanteSelecionado[0].descricao : '' }}</span>
              </div>
              <div>
                <span class="text-bold">Classe:</span>
                <span> {{ (estudanteSelecionado.length) ? getClasse(estudanteSelecionado[0].classe_descricao) :
                  '' }}</span>
              </div>
              <div>
                <span class="text-bold">Turma:</span>
                <span> {{ turma }}</span>
              </div>
              <div>
                <span class="text-bold">Bolseiro: </span>
                <span>{{ (EstudanteBolseiro.length) ? ('Sim' + '-' +
                  EstudanteBolseiro[0].ongBolsa) : 'Não' }}</span>
              </div>
              <div>
                <span class="text-bold">Saldo: </span>
                <span>{{ utilitarios.IntegerToMoneyValueFatura(saldoEstudante) }}</span>
              </div>
            </div>
            <!-- ===== FIM EXIBINDO AS INFORMAÇÕES BÁSICAS SOBRE O ESTUDANTE ===== -->

            <v-col md="12">
              <div id="table" class="center" v-if="estudanteSelecionado.length">

                 <!--====== COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->
                 <div class="header-table" v-if="desserts.length">
                  <div></div>
                  <v-btn small fab color="primary" @click="gerarHTML()"><v-icon>print</v-icon></v-btn>
                </div>
                <!--====== FIM COMBOBOX PARA FAZER O FILTRO DAS INFORMAÇÕES =======-->

                <!-- ===== INÍCIO DA TABELA ==== -->
                <v-data-table :headers="headers" :items="desserts" class="tabela-pagamento elevation-3">
                  <template v-slot:item.indice="{ item }">
                    <span>{{ desserts.indexOf(item) + 1 }}</span>
                  </template>
                  <template v-slot:item.data_compra="{ item }">
                    <span>{{ formatarData(item.data_compra) }}</span>
                  </template>
                  <template v-slot:item.mes="{ item }">
                    <span>{{ utilitarios.getMonthDescription(item.fkMes)
                    }}</span>
                  </template>
                  <template v-slot:item.valor_base="{ item }">
                    <span>{{ utilitarios.IntegerToMoneyValueFatura(item.valor_base) }}</span>
                  </template>
                  <template v-slot:item.descontos="{ item }">
                    <span>{{ utilitarios.IntegerToMoneyValueFatura(item.descontos) }}</span>
                  </template>
                  <template v-slot:item.saldo="{ item }">
                    <span>{{ utilitarios.IntegerToMoneyValueFatura(item.saldo) }}</span>
                  </template>
                  <template v-slot:item.imposto="{ item }">
                    <span>{{ utilitarios.IntegerToMoneyValueFatura(item.imposto) }}</span>
                  </template>
                  <template v-slot:item.total_rec="{ item }">
                    <span>{{ utilitarios.IntegerToMoneyValueFatura(item.total_rec) }}</span>
                  </template>
                  <template v-slot:item.total_fact="{ item }">
                    <span>{{ utilitarios.IntegerToMoneyValueFatura(item.total_fact) }}</span>
                  </template>
                </v-data-table>
                <!-- ===== FIM DA TABELA ==== -->

                <!--==== CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
                <div class="totaisContainer" v-if="desserts.length">
                  <div>
                    <span class="align-totais">Total Recibo:</span>
                    <span class="text-bold totais-font-size"> {{ utilitarios.IntegerToMoneyValueFatura(subTotais.total_fact)
                    }}</span>
                  </div>
                  <div>
                    <span class="align-totais">Total Factura:</span>
                    <span class="text-bold totais-font-size"> {{
                      utilitarios.IntegerToMoneyValueFatura(subTotais.total_rec) }}</span>
                  </div>
                </div> 
                <!--====  FIM CONTAINER DAS INFORMAÇOES SOBRE OS TOTAIS ==== -->
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>
    </v-form>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
import Swal from 'sweetalert2'
import utilitarios from '../../plugins/utilitarios'
const ls = require('local-storage')
import impressaoService from '../../services/impressaoService';
import impressaoUtilitario from '../../utilitarios/impressao.utilitario';
export default {
  data: () => ({
    estudantePesquisa: null,
    estudantesLista: [],
    estudanteSelecionado: [],
    isLoading_: false,
    overlay: false,
    search: '',
    saldoEstudante: 0,
    EstudanteBolseiro: [],
    saldoDigitado: undefined,
    utilitarios: utilitarios,
    opcoesAnoLectivos: [],
    anoLectivoSelected: null,
    emolumentosFiltrados: [],
    turma: '',
    headers: [
      { text: '#', value: 'indice' },
      { text: 'Documento', value: 'documento' },
      { text: 'Data', value: 'data_'},
      { text: 'Doc. Ref.', value: 'doc_ref'},
      { text: 'Tipo', value: 'tipo'},
      { text: 'Mês', value: 'mes'},
      { text: 'Valor Base', value: 'valor_base'},
      { text: 'Descontos', value: 'descontos' },
      { text: 'Saldo', value: 'saldo'},
      { text: 'Impostos', value: 'imposto'},
      { text: 'Total Rec.', value: 'total_rec'},
      { text: 'Total Fac..', value: 'total_fact'},
      { text: 'Modo Pag.', value: 'modo_pagamento'},
      { text: 'Nº de talão', value: 'numero_talao'},
      { text: 'Estado', value: 'estado'},
      { text: 'Operador', value: 'operador'},
    ],
    config: null
  }),

  created() {
    this.config = impressaoUtilitario.getConfig();
  },

  computed: {
    usuarioLogado() {
      return ls.get('nomeUsuario');
    },
    anoLectivoActual() {
      return ls.get('anolectivo')
    },

    isEsca() {
      return (ls.get('i_id') === 17)
    },

    subTotais() {
      let subTotais = {total_rec: 0, total_fact: 0}
      this.desserts.forEach(element => {
        let factura = isNaN(element.total_fact) || !element.total_fact ? 0 : utilitarios.MoneyValueToInteger(element.total_fact);
        let recibo = isNaN(element.total_rec) || !element.total_rec ? 0 : utilitarios.MoneyValueToInteger(element.total_rec);
        subTotais.total_fact += factura;
        subTotais.total_rec += recibo;
      })
      return subTotais;
    }
  },

  watch: {
    search(val) {
      if (val.length > 2) {
        this.estudantes = []
        return this.InitializarEstudanteLocal(val)
      }
    }
  },

  methods: {

    async InitializarEstudanteLocal(searchDB) {
      this.limparDados();
      this.isLoading_ = true;
      if (searchDB) {
        var payload = '{ "find" : "' + searchDB + '" }'
      } else {
        payload = '{ "find":"all" }'
      }
      try {
        this.estudantesLista = await axios.get('/PesquisaEstudanteLocal/' + payload).then(res => res.data)
      } catch (error) {
        Swal.fire('Error', 'Ocorreu um erro durante a pesquisa do estudante!', 'error');
      } finally {
        this.isLoading_ = false;
      }
    },

    async PesquisaLocal() {
      // this.overlay = true
      try {
        let result = await axios.post('/PesquisaEstudanteFin', this.estudantePesquisa)
        if (result.status === 200) {
          if (result.data.length >= 1) {
            this.estudanteSelecionado = result.data
            await this.pesquisarStatusSaldo(result.data[0])
            await this.vericarBolseiro(result.data[0]);
            await this.PesquisarStatusPagamento(result.data[0]);
            await this.pesquisarTurma(result.data[0]);
          } else {
            Swal.fire('Informação', 'Estudante não encontrado!', 'info');
          }
        } else {
          Swal.fire('Erro', 'Erro durante a pesquisa do estudante!', 'error')
        }
      } catch (error) {
        Swal.fire('Erro', 'Erro durante a pesquisa do estudante!', 'error');
      } finally {
        this.overlay = false;
      }
    },

    async pesquisarStatusSaldo(estudante) {
      try {
        let params = {
          matricula: estudante.numero_matricula
        }

        let result = await axios.post('/ObterStatusSaldoAluno', params).then(res => res.data);
        if (result.saldo) {
          this.saldoEstudante = result.saldo;
        } else {
          this.saldoEstudante = 0;
        }
      } catch (error) {
        Swal.fire('Erro', 'Erro durante a verificação do saldo actual do estudante!', 'error');
      }
    },

    async vericarBolseiro(estudante) {
      try {
        this.EstudanteBolseiro = await axios.get('/vericarStatusBolseiro/' + estudante.numero_matricula).then(res => res.data);
      } catch (error) {
        Swal.fire('Erro', 'Ocorreu um erro durante a verificação de bolsa!', 'error');
      }
    },

    async PesquisarStatusPagamento(estudante) {
      try {
        let params = { numero_matricula : estudante.numero_matricula };
        let result = await axios.post('/relatorio-conta-corrente', params).then(res => res.data);

        if (result.length) {
          this.desserts = result;
        }
      } catch (error) {
        Swal.fire('Erro', 'Ocoreu um erro durante o carregamento dos pagamentos!', 'error');
      }
    },

    selecionarEmolumentos() {
      this.emolumentosFiltrados = this.desserts.filter((e) => e.anolectivo == this.anoLectivoSelected.anolectivo);
    },

    async pesquisarTurma(estudante) {
      try {
        let result = await axios.get(`/pesquisarUltimaTurma/${estudante.numero_matricula}`).then(res => res.data[0]);
        if (result) {
          this.turma = result.turma;
        }
      } catch (error) {
        Swal.fire('Erro', 'Ocoreu um erro durante o carregamento dos pagamentos!', 'error');
      }
    },

    // Os dados vêm originalmento no formato "2022-11-21T10:25:40.000Z"
    // Método responsavél por converter no formato "2022-11-21"
    formatarData(data){
      if (data) {
        let newData = data.split('T');
        return newData[0];
      }
    },

    getClasse(classe) {
      switch (classe) {
        case 1:
          return '10ª'
        case 2:
          return '11ª'
        case 3:
          return '12ª'
        case 4:
          return '13ª'
      }
    },

    limparDados() {
      this.estudantePesquisa = null,
      this.estudantesLista = [],
      this.estudanteSelecionado = [],
      this.saldoEstudante = 0,
      this.EstudanteBolseiro = [],
      this.saldoDigitado = undefined,
      this.opcoesAnoLectivos = [],
      this.anoLectivoSelected = null,
      this.emolumentosFiltrados = []
    },

    // Método responsavel por criar um HTML com os dados da coleção this.dados[]
    async gerarHTML() {
      try {

        // Pegando o template HTML no banco de dados
        let documetoHtml = await axios.get('/relatorioExtratoConta').then((res) => res.data[0]);

        // trazendo o resumo dos pagamentos
        let resumoPagamento = await axios.get(`/resumoPagamento/${this.estudanteSelecionado[0].numero_matricula}`).then((res) => res.data);

        // Use um Set para armazenar os anos únicos
        let anosUnicos = new Set(resumoPagamento.map(item => item.anolectivo));
        // Converta o Set para um array
        let anosLectivosPagamentos = Array.from(anosUnicos);
        let nome = (this.estudanteSelecionado.length) ? this.estudanteSelecionado[0].nome : '';
        let curso = (this.estudanteSelecionado.length) ? this.estudanteSelecionado[0].descricao : '';
        let classe = (this.estudanteSelecionado.length) ? this.getClasse(this.estudanteSelecionado[0].classe_descricao) : '' ;
        let itemsPagamentosGerais = '';
        let pagamentosGerais = '';
        let totalGeral1 = 0;
        let totalGeral2 = 0;
        let totalGeral3 = 0;

        for (let i = 0; i < anosLectivosPagamentos.length; i++) {
          let pagamentos = resumoPagamento.filter((a) => a.anolectivo == anosLectivosPagamentos[i])

          for (let c = 0; c < pagamentos.length; c++) {
            itemsPagamentosGerais += `
            <tr>
              <td> ${pagamentos[c].produto}-${classe}-${anosLectivosPagamentos[i]}</td> 
              <td class="right-text"> ${this.utilitarios.IntegerToMoneyValueFatura(pagamentos[c].fixado)} </td>
              <td class="right-text"> ${this.utilitarios.IntegerToMoneyValueFatura(pagamentos[c].pago)} </td>
              <td class="right-text"> ${this.utilitarios.IntegerToMoneyValueFatura(pagamentos[c].divida)} </td>
            </tr>`

            totalGeral1 += (isNaN(pagamentos[c].fixado) || !pagamentos[c].fixado) ? 0 : parseInt(pagamentos[c].fixado);
            totalGeral2 += (isNaN(pagamentos[c].pago) || !pagamentos[c].pago) ? 0 : parseInt(pagamentos[c].pago);
            totalGeral3 += (isNaN(pagamentos[c].divida) || !pagamentos[c].divida) ? 0 : parseInt(pagamentos[c].divida);
          }
          
          pagamentosGerais += `
          <div> 
            <tr><td class="bold-span">${anosLectivosPagamentos[i]}</td> <td></td> <td></td> <td></td></tr>
            ${itemsPagamentosGerais}
            <tr>
              <td></td>
              <td class="right-text bold-span"> ${this.utilitarios.IntegerToMoneyValueFatura(totalGeral1)} </td>
                <td class="right-text bold-span"> ${this.utilitarios.IntegerToMoneyValueFatura(totalGeral2)} </td>
                <td class="right-text bold-span"> ${this.utilitarios.IntegerToMoneyValueFatura(totalGeral3)} </td>
            </tr>
          </div>`

          itemsPagamentosGerais = '';
          totalGeral1 = 0;
          totalGeral2 = 0;
          totalGeral3 = 0;
        }

        let dadosPrincipal = '';
        let dadosTemporario = '';
        let i = 1;
        let dataHoraString = this.data_hora();
        var partes = dataHoraString.split(' ');
        let dataString = partes[0];
        let horaString = partes[1];
        let nomeInstituicao = this.isEsca ? 'Escola de Saúde Castelo' :  'Instituto Técnico Privado de Saúde Ilha da Verdade';
        let localizacao = this.isEsca ? 'Benfica, Rua D, Zona verde, junto a fabrica de blocos, rua das Tendas' : 'Distrito 11 de Novembro - Rua da Volvo'
        let numeroContribuente = this.isEsca ? '5419011247' : '5417113387'
        let numeroTelefone = this.isEsca ? '934467397' : '923310818'
        let email = this.isEsca ? 'secretaria@esca.co.ao' : 'secretaria.civ21@instit'
        let webSite = this.isEsca ? 'www.esca.co.ao' : 'www.grupoilhadaverdade.com'
        let ciclo = '2º'
        let template = documetoHtml.documento;

        this.desserts.forEach(element => {
          dadosTemporario = documetoHtml.documentoiteracao1.replace('{{index}}', i),
          dadosTemporario = dadosTemporario.replace('{{documento}}', element.documento),
          dadosTemporario = dadosTemporario.replace('{{data}}', element.data_)
          dadosTemporario = dadosTemporario.replace('{{doc_ref}}', element.doc_ref)
          dadosTemporario = dadosTemporario.replace('{{tipo}}', element.tipo)
          dadosTemporario = dadosTemporario.replace('{{mes}}', element.mes)
          dadosTemporario = dadosTemporario.replace('{{valor_base}}', this.utilitarios.IntegerToMoneyValueFatura(element.valor_base))
          dadosTemporario = dadosTemporario.replace('{{descontos}}', this.utilitarios.IntegerToMoneyValueFatura(element.descontos))
          dadosTemporario = dadosTemporario.replace('{{saldo}}', this.utilitarios.IntegerToMoneyValueFatura(element.saldo))
          dadosTemporario = dadosTemporario.replace('{{imposto}}', this.utilitarios.IntegerToMoneyValueFatura(element.imposto))
          dadosTemporario = dadosTemporario.replace('{{total_rec}}', this.utilitarios.IntegerToMoneyValueFatura(element.total_rec))
          dadosTemporario = dadosTemporario.replace('{{total_fac}}', this.utilitarios.IntegerToMoneyValueFatura(element.total_fact))
          dadosTemporario = dadosTemporario.replace('{{modo_pagamento}}', element.modo_pagamento)
          dadosTemporario = dadosTemporario.replace('{{numero_talao}}', element.numero_talao)
          dadosTemporario = dadosTemporario.replace('{{estado}}', element.estado)
          dadosTemporario = dadosTemporario.replace('{{operador}}', element.operador)

          dadosPrincipal += dadosTemporario;
          i++;
        })

        template = template.replace('{{NomeInstituicao}}', nomeInstituicao);
        template = template.replace('{{LocalInstituicao}}', localizacao);
        template = template.replace('{{NumeroContribuente}}', numeroContribuente);
        template = template.replace('{{NumeroTelefone}}', numeroTelefone);
        template = template.replace('{{Email}}', email);
        template = template.replace('{{WebSite}}', webSite);
        template = template.replace('{{NomeEstudante}}', nome);
        template = template.replace('{{Ciclo}}', ciclo);
        template = template.replace('{{Classe}}', classe);
        template = template.replace('{{Curso}}', curso);
        template = template.replace('{{Turma}}', this.turma);
        template = template.replace('{{subtotal1}}', this.utilitarios.IntegerToMoneyValueFatura(this.subTotais.total_rec));
        template = template.replace('{{subtotal2}}', this.utilitarios.IntegerToMoneyValueFatura(this.subTotais.total_fact));
        template = template.replace('{{subtotal3}}', '');
        template = template.replace('{{subtotal4}}', '');
        template = template.replace('{{subtotal5}}', '');
        template = template.replace('{{subtotal6}}', '');
        template = template.replace('{{tabelaPrincipal}}', dadosPrincipal);
        template = template.replace('{{DataExtrato}}', dataString);
        template = template.replace('{{HoraExtrato}}', horaString);
        template = template.replace('{{AutorEmissao}}', this.usuarioLogado);   
        template = template.replace('{{resumoGeralpagamentos}}', pagamentosGerais);   

        this.$store.state.loading_pdf = true;   
        let options = {
          'format': 'A4',
          'orientation': 'landscape',
          'border': {'right': '4mm', 'left': '4mm'},
          'header': {'height': '3mm'},
          'footer': {'height': '1mm'}
        }
        
      
        impressaoService.htmlToPdf(template, options);
      } catch (error) {
        this.$store.state.loading_pdf = false;
        Swal.fire('Erro', 'Ocorreu um erro durante a impressão', 'error');
      }
    },

    // Método responsavél por guardar a data atual
    data_hora() {
      let data = new Date()
      return data.getDate() + '/' + (data.getMonth() + 1) + '/' + (data.getFullYear()) + ' ' + (data.getHours()) + ':' + (data.getMinutes()) + ':' + (data.getSeconds())
    }
  }
}

</script>

<style scoped>
/* estilo informações do estudante */
.text-bold {
  font-weight: bold;
}
.totais-font-size {
  font-size: 17px;
}
.infoEstudanteContainer {
  width: 100%;
  margin: 0 0 5px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.text-bold {
  font-weight: bold;
}
.theme--light.tabela-pagamento>.v-data-table__wrapper>table>thead>tr>th {
  color: white;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
.tabela-pagamento {
  margin-right: 3px;
  margin-left: 3px;
}
.tabela-pagamento thead {
  background-color: #006699;
}
.align-totais {
  margin-left: 15px;
}
.totais-font-size {
  font-size: 17px;
}
.totaisContainer {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
  width: 100%;
  padding: 10px;
  background-color: #fff;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  margin-bottom: 10px;
}
.infoEstudanteContainer {
  width: 100%;
  margin: 0 0 5px 20px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
.bold_text_span {
  font-weight: bold;
}
.header-table {
  display: flex;
  justify-content: space-between;
  border-top: 8px #ebeb34 solid; 
  padding: 5px 50px 5px 5px;
}
.combo_box_container {
  display: flex;
  justify-content: space-between;
  width: 250px;
}
</style>